// extracted by mini-css-extract-plugin
export default {"arrowIcon":"atohKn","arrowIconOpened":"btohKn"};